import React from "react";
const SvgDsBalcony = props => (
  <svg fill="none" viewBox="0 0 24 25" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M7 3.5a.5.5 0 000 1h.49v9H2.5a.5.5 0 000 1h.9v7h-.9a.5.5 0 000 1h19a.5.5 0 000-1h-.9v-7h.9a.5.5 0 000-1h-5.08v-9h.493a.5.5 0 100-1H7zm8.42 10v-9H8.49v9h6.93zm-11.02 8v-7h2.24v7H4.4zm3.24 0v-7h.105l.032.001H9.88V21.5H7.64zm3.24 0v-6.999h2.24V21.5h-2.24zm3.24 0v-6.999h2.102l.032-.001h.106v7h-2.24zm3.24 0v-7h2.24v7h-2.24z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M14.225 6.297a.5.5 0 01-.011.708l-3.077 2.98a.5.5 0 01-.695-.718l3.076-2.98a.5.5 0 01.707.01zm-2.504.043a.5.5 0 01-.01.707l-1.276 1.235a.5.5 0 01-.696-.718l1.275-1.235a.5.5 0 01.707.01z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsBalcony;
